import { action, makeObservable, observable } from 'mobx';
import { singleton } from 'tsyringe';

import { GetCurrentStudentClassesCollaboration } from '@/application/collaborations/get-current-student-class.collaboration';
import { StudentClassIdentifier } from '@/application/commons/enums/student-class.enum';
import type { StudentClassesDto } from '@/application/interfaces/pegasus.gateway';

import { StudentClassesStore } from '../stores/studentClasses.store';
import { ClassifiersModel } from './classifiers.model';

@singleton()
export class StudentClassesModel {
  @observable shouldShowPaywall = false;
  @observable currentStudentClass: StudentClassesDto;
  @observable paywallType: string;
  @observable isLoading: boolean;

  constructor(
    private readonly currentStudentClassesCollaboration: GetCurrentStudentClassesCollaboration,
    private readonly classifiersModel: ClassifiersModel,
    private readonly studentClassesStore: StudentClassesStore,
  ) {
    makeObservable(this);
  }

  @action
  async onInit() {
    if (this.classifiersModel.selectedClassifier?.guid) {
      this.getCurrentStudentClasses();
    }
  }

  @action.bound
  async getCurrentStudentClasses() {
    this.isLoading = true;
    const classifierGuid = this.classifiersModel.selectedClassifier?.guid;

    if (!classifierGuid) {
      this.shouldShowPaywall = true;
      this.isLoading = false;
      return;
    }

    const { data, identifier } = await this.currentStudentClassesCollaboration.run(classifierGuid);

    if (identifier === StudentClassIdentifier.CurrentStudentClassIsAvailable) {
      this.shouldShowPaywall = false;
    }

    if (
      identifier === StudentClassIdentifier.CurrentStudentClassHasExpired ||
      identifier === StudentClassIdentifier.CurrentStudentClassHasNotStarted ||
      identifier === StudentClassIdentifier.CurrentStudentClassNotFound
    ) {
      this.shouldShowPaywall = true;
    }

    this.currentStudentClass = data;
    this.studentClassesStore.setCurrentStudentClass(data);
    this.paywallType = identifier;
    this.isLoading = false;
  }
}
